import React from 'react';
import { useAuthStore } from '../../stores/authStore';
import { CloudSave } from './CloudSave';
import { Dialog } from '../shared/Dialog';
import { ClientOnly } from '../ClientOnly';

export const LoginModal: React.FC = () => {
  const { showLoginModal, closeLoginModal } = useAuthStore();

  return (
    <Dialog
      isOpen={showLoginModal}
      onClose={closeLoginModal}
      size="md"
    >
      <CloudSave onSuccess={closeLoginModal} />
    </Dialog>
  );
};

export const ClientOnlyLoginModal: React.FC = () => {
  return (
    <ClientOnly>
      <LoginModal />
    </ClientOnly>
  );
}; 